import {
    Dialog,
    Transition,
} from "@headlessui/react";
import { useMutation } from '@tanstack/react-query';
import TrashIcon from "../Icons/TrashIcon";
import { queryClient } from "../../main";
import { CircleX } from "lucide-react";
import { Fragment } from 'react'
interface DeleteModalProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    mutationFn: (id: string) => Promise<void>;
    itemId: string;
    queryKey?:string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, setIsOpen, mutationFn, itemId, queryKey }) => {
    const { mutate: deleteItem } = useMutation({
        mutationFn: () => mutationFn(itemId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [queryKey] });
            setIsOpen(false);
        },
    });

    return (
        <Transition appear show={isOpen}>
            <Dialog
                as="div"
                className="relative z-[999999999999999] focus:outline-none"
                onClose={() => setIsOpen(false)}
            >
                          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

                <div className="fixed inset-0 z-[999999999999999] w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
                        >
                            <div className="w-full max-w-md rounded-xl p-6 text-secondaryText bg-white border-black/30 shadow border sm:min-w-[400px] relative">
                            <button onClick={() => setIsOpen(false)} className="absolute right-6">
                                <CircleX/>
                            </button>
                                <h3 className="text-base/7 font-medium text-center pt-6">
                                    Confirmation Message
                                </h3>
                                <p className="mt-2 text-sm/6 mb-2 text-center">
                                    Are you sure you want to delete this item?
                                </p>
                                <div className="mt-4 flex justify-center">
                                    <button
                                        className="gap-2 rounded-md hover:bg-red-800 bg-[#f81911] py-1.5 px-3 text-sm/6 font-semibold shadow-inner shadow-white/10 focus:outline-none duration-300 transition-all text-white flex items-center"
                                        onClick={() => deleteItem()}
                                    >
                                        Delete <TrashIcon />
                                    </button>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default DeleteModal;
